import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  GetMyMarathonsWithUnfinishedRegistrationParams,
  GetMyMarathonsWithUnfinishedRegistrationResponse,
} from "api/api/marathonsApi/types";
import axios from "axios";

export const getMyMarathonsWithUnfinishedRegistration = createAsyncThunk<
  GetMyMarathonsWithUnfinishedRegistrationResponse,
  GetMyMarathonsWithUnfinishedRegistrationParams
>(
  "marathons/getMyMarathonsWithUnfinishedRegistration",
  async (params, { rejectWithValue }) => {
    try {
      const data = await MarathonsAPI.getMyMarathonsWithUnfinishedRegistration(
        params
      );
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting my marathons with unfinished registration",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting my marathons with unfinished registration", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
